import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  FunnelCard,
  FunnelCardLabel,
  FunnelCardTop
} from 'blocks/FunnelCard/FunnelCard';
import TwoColumnBlock from 'blocks/TwoColumnBlock';
import IconComponent from 'components/IconComponent';
import {
  IconNameType,
  UppercaseIconNameType
} from 'components/IconComponent/svg-sprites-info';
import PageHeader from 'components/PageHeader/PageHeader';
import PageStackBlock from 'components/PageStackBlock/PageStackBlock';
import NakedButton from 'elements/NakedButton';
import { FormType } from 'utils/hooks/useForm';

const CLASS_SIZES = ['0-25', '25-50', '50-100', '100+'] as const;
export type ClassSizeType = typeof CLASS_SIZES[number];
const CLASS_SIZES_ICON: {
  [key in ClassSizeType]: IconNameType | UppercaseIconNameType;
} = {
  '0-25': 'USER',
  '25-50': 'USERGROUP',
  '50-100': 'USERGROUP_LARGE',
  '100+': 'USERGROUP_HUGE'
};

const ClassSizeScreen = ({
  form,
  onSubmit
}: {
  form: FormType;
  onSubmit: (size: ClassSizeType) => void;
}) => (
  <PageStackBlock>
    <PageHeader
      headline={<FormattedMessage id="v2 funnel class size headline" />}
      text={<FormattedMessage id="v2 funnel class size info" />}
    />

    <TwoColumnBlock gap="M">
      {CLASS_SIZES.map((size) => (
        <NakedButton
          key={size}
          onClick={() => {
            form.setField('class_size', size);
            if (onSubmit) {
              onSubmit(size);
            }
          }}
        >
          <FunnelCard>
            <FunnelCardTop>
              <IconComponent
                icon={CLASS_SIZES_ICON[size]}
                fill="PRIMARY"
                size={5}
                circleBackground="PRIMARY_LIGHT"
              />
            </FunnelCardTop>
            <FunnelCardLabel>{size}</FunnelCardLabel>
          </FunnelCard>
        </NakedButton>
      ))}
    </TwoColumnBlock>
  </PageStackBlock>
);

export default ClassSizeScreen;
